module.exports = __webpack_public_path__ + "static/Depositphotos_26671801_m-2015-e47fea0411958705fc5324c0c23405da.jpg";